import axios from "axios";
import { loginreq, req,reqGet} from "../axiosFun";

// 查询轮播图列表
export const getCarouselList = params => {
    return reqGet("get", "/app-yijiu-backstage/getCarouselList", params);
};

// 删除轮播图
export const deleteCarousel = params => {
    return reqGet("get", "/app-yijiu-backstage/deleteCarousel", params);
};

  // 增加轮播图
export const addCarousel = params => {
    return req("post", "/app-yijiu-backstage/addCarousel", params);
};

  // 修改轮播图
  export const updateCarousel = params => {
    return req("post", "/app-yijiu-backstage/updateCarousel", params);
};


// WEBPACK FOOTER //
// ./src/api/manage/carousel.js